// 도메인 엔티티 — SharePoint 리스트 매핑 타입 (web/api 공유)
// 날짜/시간 문자열은 ISO 8601(KST 입력 → 서버에서 UTC 변환)을 기본으로 한다.
// SharePoint LeaveRequests.LeaveType / Status Choice 값과 1:1 일치(한글)
export const LEAVE_TYPES = ['연차', '오전반차', '오후반차', '병가', '경조', '공가'];
export const LEAVE_STATUSES = ['상신', '승인대기', '승인', '반려', '취소'];
/** 반차 여부(0.5일) */
export function isHalfDay(t) {
    return t === '오전반차' || t === '오후반차';
}
// 임직원 증명서 등 첨부 문서 — SharePoint 문서 라이브러리(EmployeeDocs/<upn>)에 저장
export const DOC_CATEGORIES = ['재직증명서', '경력증명서', '자격증', '통장사본', '주민등록등본', '기타'];
// 자료실(회사 공용 문서 양식) — SharePoint CompanyDocs/ 저장.
//  external = 외부 제출 문서 양식(기존 CompanyDocs 루트를 무이전 승계),
//  internal = 내부 문서 양식(CompanyDocs/내부문서양식 하위폴더)
//  training = 내부교육자료(CompanyDocs/교육자료 하위폴더)
export const RESOURCE_CATEGORIES = ['external', 'internal', 'training'];
export const RESOURCE_CATEGORY_LABELS = {
    external: '외부 제출 문서 양식',
    internal: '내부 문서 양식',
    training: '내부교육자료',
};
/** 빈 프로파일 기본값 */
export function emptyProfile() {
    return { careerYears: '', educations: [], careers: [], certificates: [], projects: [] };
}
/**
 * 근무 경력사항(careers)의 기간들을 파싱·겹침 병합하여 총 경력기간 문자열 산출.
 * - 기간 형식: 'YYYY.MM ~ YYYY.MM' 또는 'YYYY.MM ~ 재직중/현재/진행중'(종료=현재 월).
 * - 겹치는/연속 구간은 한 번만 합산(중복 방지), 공백 구간은 제외.
 * @returns 예: '32년', '5년 6개월' (파싱 불가 시 '')
 */
export function careerDuration(careers, now = new Date()) {
    const nowIdx = now.getFullYear() * 12 + now.getMonth(); // month 0-based
    const re = /(\d{4})\s*\.\s*(\d{1,2})\s*~\s*(?:(\d{4})\s*\.\s*(\d{1,2})|재직중|현재|진행중|재학중)/;
    const ivs = [];
    for (const c of careers) {
        const m = re.exec(c.period ?? '');
        if (!m)
            continue;
        const s = Number(m[1]) * 12 + (Number(m[2]) - 1);
        const e = m[3] ? Number(m[3]) * 12 + (Number(m[4]) - 1) : nowIdx;
        if (e >= s)
            ivs.push([s, e]);
    }
    if (!ivs.length)
        return '';
    ivs.sort((a, b) => a[0] - b[0]);
    let total = 0;
    let [cs, ce] = ivs[0];
    for (let i = 1; i < ivs.length; i++) {
        const [s, e] = ivs[i];
        if (s <= ce + 1)
            ce = Math.max(ce, e); // 겹치거나 연속(공백 0) → 병합
        else {
            total += ce - cs + 1;
            cs = s;
            ce = e;
        }
    }
    total += ce - cs + 1;
    const years = Math.floor(total / 12);
    const months = total % 12;
    return months ? `${years}년 ${months}개월` : `${years}년`;
}
//# sourceMappingURL=domain.js.map